module.exports = __webpack_public_path__ + "static/img/13.fa753a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcho/11/13.png
// module id = arU/
// module chunks = 0